export const BASE_API_URL = '___api_url___';
export const APP_TITLE = 'Suinicola Postioma - Sistema Gestione Qualità';
